import { EntityUpgrades, Generator, ResourceCost } from '../../types/game-types';

export const getModifiedGeneratorCost = (upgrades: EntityUpgrades, generator: Generator): ResourceCost => {
  const costReduction = upgrades?.loyalServants?.multiplier ?? 0;

  return Object.fromEntries(
    Object.entries(generator.cost).map(([currency, cost]) => [
      currency,
      Math.max(0.1, (cost * (100 - costReduction)) / 100),
    ]),
  );
};
